'use strict';

import React, {Component, useState} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";

import {FaExclamationCircle} from "react-icons/fa";

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import appStore from '@uw-it-sis/lib-react/lib/AppStore';

import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';
import acknowledgementsStore from "./AcknowledgementsStore";
import RegistrationFailure from "../registration/RegistrationFailure";

const VoterRegistration = (props) => {
    const key = "voter";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? null;
    const [value, setValue] = useState(storeValue);
    const handleChange = (e) => {
        setValue(e.target.value);
    }

    let disableButton = value === null;
    const submitForm = (e) => {
        e.preventDefault();
        if (!disableButton) {
            props.updateAcknowledgement(key, value);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">Voter Registration</h4>
            <p><small>This notice is in compliance with <a href="http://apps.leg.wa.gov/RCW/default.aspx?cite=29A.08.310" target="_blank">RCW 29A.08.310</a>.</small></p>
            <p>Civic engagement is an essential feature of the University of Washington's vision for its students and alumni as global citizens and leaders.</p>
            <p>If you are eligible to vote in the United States, please take a couple minutes to register to vote or update your registration to your current
                address. If you are not eligible to vote, there are many other ways you can be involved in civic engagement through public service, student activism,
                and campus organizations.</p>
            <p><a href="https://www.vote.org/am-i-registered-to-vote/" target="_blank">Not sure where or if you're registered? Check here!</a></p>
            <Form onSubmit={submitForm}>
                <fieldset className="mb-3">
                    <legend>Do you want to register to vote? <span className="sr-only">A choice is required to continue</span></legend>
                    <Form.Check id={key + "-yes-wa"}>
                        <Form.Check.Input
                            name={key}
                            type="radio"
                            value="yes-washington"
                            defaultChecked={value === "yes-washington"}
                            onChange={handleChange} />
                        <Form.Check.Label className="d-inline me-2 align-middle">
                            Yes, in Washington State
                        </Form.Check.Label>
                    </Form.Check>
                    <div className="form-check ps-4">
                        <small><a href="https://www.sos.wa.gov/elections/voters/voter-eligibility.aspx" target="_blank">Learn who is eligible to vote in
                            Washington State</a> or <a href="https://www.sos.wa.gov/elections/voters/voters-away-at-college.aspx" target="_blank">learn more
                            about voting in Washington for college students</a></small>
                    </div>
                    <Form.Check id={key + "-yes-state"}>
                        <Form.Check.Input
                            name={key}
                            type="radio"
                            value="yes-another"
                            defaultChecked={value === "yes-another"}
                            onChange={handleChange} />
                        <Form.Check.Label className="d-inline me-2 align-middle">
                            Yes, in another state
                        </Form.Check.Label>
                    </Form.Check>
                    <Form.Check id={key + "-no"}>
                        <Form.Check.Input
                            name={key}
                            type="radio"
                            value="no"
                            defaultChecked={value === "no"}
                            onChange={handleChange} />
                        <Form.Check.Label className="d-inline me-2 align-middle">
                            No, I am already registered, do not wish to register to vote, or am not eligible to vote.
                        </Form.Check.Label>
                    </Form.Check>
                </fieldset>
                <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
            </Form>
        </>
    )
}

const Upass = (props) => {
    const key = "upass";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }

    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">Important notice to students about U-PASS membership:</h4>
            <p>U-PASS powered by ORCA is a universal program for all eligible students associated with UW Seattle. All students
                who pay the Service &amp; Activities Fee (SAF) are U-PASS members and are required to pay the quarterly U-PASS
                fee. Students not eligible for Universal U-PASS can purchase U-PASS membership.</p>
            <p> All U-PASS Program participants <a href='http://www.transportation.uw.edu/student-u-pass'
                                                   target='_blank'>(www.transportation.uw.edu/student-u-pass)</a> must comply with the U-PASS Program Terms of
                Use <a href='http://www.transportation.uw.edu/u-pass-terms-of-use'
                       target='_blank'>(www.transportation.uw.edu/u-pass-terms-of-uses)</a>.</p>
            <p>For more information on the universal U-PASS go to <a
                href='https://www.washington.edu/facilities/transportation/commuterservices/u-pass/student'
                target='_blank'>https://www.washington.edu/facilities/transportation/commuterservices/u-pass/student</a>.
            </p>
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I acknowledge that I have read the U-PASS membership notice.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

const FinancialResponsibility = (props) => {
    const key = "finliab";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }
    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">University of Washington Financial Responsibility Agreement</h4>
            <p>I acknowledge that my right to register is expressly conditioned upon my agreement to pay all the costs of all
                tuition, fees, and any additional costs incurred by me. I understand and acknowledge that any educational
                instruction may be presented in a variety of formats (i.e. remote instruction), and I hereby agree to pay all of my
                University of Washington (“UW”) balances, debts, and charges pursuant to UW policies notwithstanding such
                modifications to the format of instruction. I understand that administrative, clerical, or technical billing errors
                do not absolve me of this responsibility.</p>
            <p>I acknowledge that the UW will notify me of my outstanding charges and debts via email and MyUW. I agree to regularly
                check both my UW email and/or any emails I provided the UW and MyUW tuition statement.</p>
            <p>I agree if any payments made to my student account are returned by the bank for any reason I will repay the original
                amount of the payment plus a returned payment fee of $25.00.</p>
            <p>I agree that should I fail to pay any past due accounts (by the required due date), a late payment fee may be
                assessed ($50 for balances between $50.00 and $249.99 and $120.00 for balances of $250.00 and greater).
                Additionally, my right to register for classes and other services, including, but not limited to transcripts and
                diplomas, may be withheld in accordance with Washington State law and UW policy until I pay all past-due balances.</p>
            <p><strong>Collection Fees:</strong> I understand and accept that if I fail to pay my student account bill or any monies due and
                owing the UW by the scheduled due date, and fail to make acceptable payment arrangements to bring my account
                current, the UW may refer my delinquent account to a collection agency. I further understand that if the UW refers
                my student account balance to a third party for collection, a collection fee will be assessed and will be due in
                full at the time of the referral to the third party. The fee will be based on a percentage at a maximum of 40% of
                the debt as authorized by RCW 19.16.500, and may include reasonable costs and expenses including attorney’s fees.
                Finally, I understand that my delinquent account may be reported to one or more of the national credit bureaus.</p>
            <p>I authorize the UW and their respective agents and contractors to contact me regarding any loan or debt, including
                repayment of my loan or debt to my UW email or other email provided the UW and to my current or any future number
                that I provide for my cellular phone or other wireless device using automated telephone dialing equipment or
                artificial or pre-recorded voice or text messages.</p>
            <p><i>The provisions of this Financial Responsibility Agreement will be governed by the laws of the State of Washington
                and applicable laws of the United States,without regard to conflict of law rules. I agree that any action
                arising out of or relating to this agreement be brought in the state courts located in King County, Washington.
                I consent to the jurisdiction and venue of these courts.</i></p>
            <p>I agree to notify the UW within 30 days after my local or permanent address changes. While I am a UW student, I will
                update my address through the MyUW portal.</p>
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I have read and agree to the terms of this agreement.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

const Meningitis = (props) => {
    const key = "meningo";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }
    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    let content;

    switch (acknowledgementsStore.getCampus()) {
        case Campus.tacoma:
            content =
                <>
                    <p>The Centers for Disease Control and Prevention (CDC) has recommended that college students, especially those who live
                        in on-campus housing, in consultation with their parents, partners, or family members, seriously consider getting
                        the vaccine that protects against meningococcal meningitis. CDC research indicates that compared to other
                        undergraduates, students living in group situations such as shared apartments or other shared living spaces are
                        about 7 times as likely to contract the meningococcal disease. College students living in these environments are
                        also at modestly increased risk of the disease when compared to non-college persons of their age. One possible
                        explanation for this increased chance of infection is that living in close proximity to many other people increases
                        the chance of exposure to meningococcal bacteria spread by respiratory tract secretions.</p>
                    <p>Meningococcal meningitis is a very serious form of bacterial meningitis, an infection involving the membranes lining
                        the brain and spinal cord. Even with the very best of treatment, about 10 percent of patients die&mdash;and many of
                        those who recover suffer permanent injury. Initial symptoms of meningococcal meningitis include high fever,
                        headache, stiff neck, rash, nausea, vomiting, confusion and sleepiness.&nbsp;&nbsp;If undiagnosed and untreated, the
                        illness can cause death within 24 to 48 hours.</p>
                    <p>Students developing such symptoms are encouraged to seek immediate medical evaluation at the nearest emergency
                        department. The closest emergency department to the University of Washington Tacoma campus is Jt. Joseph Medical
                        Center located at 1717 S J St., Tacoma, WA 98405, telephone (253) 426-4101. An alternative would be Tacoma General
                        Hospital located at315 Martin Luther King Jr Way, Tacoma, WA, telephone (253) 403-1000.</p>
                    <p>The currently available meningococcal vaccine (Menactra) is a purified, inactivated preparation that provides
                        protection against the A, C, Y and W-135 serogroups of the bacteria. A single vaccine injection can provide
                        protection for an estimated 10 years, and is 85-95&#37; protective within ten days after it has been administered.
                        The vaccine does not cover serogroup B meningococcal infections, which are responsible for about 33 percent of all
                        cases. Side effects associated with this immunization are usually temporary and mild, and include localized pain and
                        redness at the site of the injection lasting one to two days and, occasionally, unexpected hypersensitivity
                        reactions. Students interested in receiving the vaccine should see their primary care providers.</p>
                    <p>A rare condition called Guillain-Barr&eacute; syndrome (GBS) has occurred 6 weeks following the vaccine in a very
                        small number of patients. The number of patients is so small that the CDC is not able to conclude that the vaccine
                        causes GBS. As a precaution, the vaccine is usually not given to patients with a prior history of GBS unless the
                        risk of meningococcal disease is high. </p>
                    <p>If you have questions about the meningococcal vaccine, please contact your personal healthcare provider. Additional
                        information about meningococcal meningitis is available through the CDC at: <a
                            href='http://www.cdc.gov/meningitis/index.htm' target='_new'>http://www.cdc.gov/meningitis/index.htm</a>.</p>
                </>
            break;
        case Campus.bothell:
            content =
                <>
                    <p>The Centers for Disease Control and Prevention (CDC) has recommended that college freshmen, especially those who live
                        in dormitories or residence halls, in consultation with their parents, seriously consider getting the vaccine that
                        protects against meningococcal meningitis. CDC research indicates that compared to other undergraduate students,
                        college freshmen living in group situations such as residence halls are about 7 times as likely to contract the
                        meningococcal disease. College freshmen are also at modestly increased risk of the disease when compared to
                        non-college persons of their age. One possible explanation for this increased chance of infection is that living in
                        close proximity to many other people increases the chance of exposure to meningococcal bacteria spread by
                        respiratory tract secretions.</p>
                    <p>Meningococcal meningitis is a very serious form of bacterial meningitis, an infection involving the membranes lining
                        the brain and spinal cord. Even with the very best of treatment, about 10 percent of patients die&mdash;and many of
                        those who recover suffer permanent injury. Initial symptoms of meningococcal meningitis include high fever,
                        headache, stiff neck, rash, nausea, vomiting, confusion and sleepiness.&nbsp;&nbsp;If undiagnosed and untreated, the
                        illness can cause death within 24 to 48 hours. Students developing such symptoms are encouraged to seek prompt
                        medical evaluation at the nearest emergency room.</p>
                    <p>The currently available meningococcal vaccine (Menactra) is a purified, inactivated preparation that provides
                        protection against the A, C, Y and W-135 serogroups of the bacteria. A single vaccine injection can provide
                        protection for an estimated 10 years, and is 85-95&#37; protective within ten days after it has been administered.
                        The vaccine does not cover serogroup B meningococcal infections, which are responsible for about 33 percent of all
                        cases. Side effects associated with this immunization are usually temporary and mild, and include localized pain and
                        redness at the site of the injection lasting one to two days and, occasionally, unexpected hypersensitivity
                        reactions. Check with your primary care provider to see if the vaccine is available at their office or clinic and if
                        not, if they can recommend an alternative site.</p>
                    <p>A rare condition called Guillain-Barr&eacute; syndrome (GBS) has occurred 6 weeks following the vaccine in a very
                        small number of patients. The number of patients is so small that the CDC is not able to conclude that the vaccine
                        causes GBS. As a precaution, the vaccine is usually not given to patients with a prior history of GBS unless the
                        risk of meningococcal disease is high.</p>
                    <p>The vaccine is available at student primary care provider offices, health clinics, and county health departments.
                        Students 18 years and younger are eligible to receive the vaccine free through the Vaccine for Children (VFC)
                        program.</p>
                    <p>If you have questions about the meningococcal vaccine, please check the Hall Health Primary Care Center website at <a
                        href='http://www.hallhealthcenter.com' target='_hhc'>www.hallhealthcenter.com</a> or call the Immunization
                        Clinic (206-685-1018). College-bound students need to plan ahead to get meningococcal vaccine.</p>
                </>
            break;
        default:
            content =
                <>
                    <p>
                        The Centers for Disease Control and Prevention (CDC) recommends that college freshmen, especially those who live in
                        residence halls, in consultation with their parents, get the vaccine that protects against meningococcal meningitis.
                        CDC research indicates that college freshmen living in group situations such as residence halls are about 7 times as
                        likely to contract meningococcal disease as other students. One possible explanation for this is that being close to
                        many other people increases the chance of exposure to meningococcal bacteria spread by respiratory tract secretions.
                    </p>
                    <p>
                        Meningococcal meningitis is a very serious form of bacterial meningitis, an infection involving the membranes lining
                        the brain and spinal cord. Even with the very best of treatment, about 10 percent of patients die&mdash;and many of
                        those who recover suffer permanent injury. Initial symptoms of meningococcal meningitis include high fever,
                        headache, stiff neck, rash, nausea, vomiting, confusion and sleepiness.&nbsp;&nbsp;If undiagnosed and untreated, the
                        illness can cause death within 24 to 48 hours. Students developing such symptoms should seek immediate medical
                        evaluation at the UW student health service, called Hall Health Primary Care Center, or go to the nearest emergency
                        room, which for campus is located at the UW Medical Center on the south end of the campus.
                    </p>
                    <p>
                        The currently available meningococcal conjugate vaccine provides protection against 4 types of the bacteria. A single
                        vaccine is 85-95&#37; protective within ten days after it has been administered. The vaccine does not cover type B
                        meningococcal infections, which are responsible for about 33&#37; of all cases. Side effects associated with this
                        immunization are usually temporary and mild, and include localized pain and redness at the site of the injection
                        lasting one to two days and, occasionally, allergic-type reactions.
                    </p>
                    <p>
                        <strong>If you have never had a meningococcal vaccine, the CDC recommends that you get it before you start school at the
                        UW. If you received a vaccine before age 16 years, the CDC recommends you get a booster dose before you start
                        school at the UW, if you will be 16 or older. The CDC recommendations can be found at: <a
                        href='http://www.cdc.gov/mmwr/preview/mmwrhtml/mm6003a3.htm'
                        target='_mmwr'>www.cdc.gov/mmwr/preview/mmwrhtml/mm6003a3.htm</a></strong>
                    </p>
                    <p>
                        The vaccine is available by appointment at the Hall Health Primary Care Center. Alternative sites and student primary
                        care providers may have vaccine available as well.
                    </p>
                    <p>
                        If you have questions about the meningococcal vaccine, please check the Hall Health Primary Care Center website at <a
                        href='http://www.hallhealthcenter.com' target='_hhc'>www.hallhealthcenter.com</a> or call the Immunization
                        Clinic (206-685-1018).
                    </p>
                </>
    }

    return (
        <>
            <h4 className="h2">Meningococcal Meningitis Notice</h4>
            {content}
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I acknowledge that I have read the meningococcal meningitis notice.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

const Riaa = (props) => {
    const key = "riaa";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }
    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">File-Sharing and Copyright Infringement</h4>
            <p>Under copyright law, it is illegal to download or share copyrighted materials such as music or movies without the
                permission of the copyright owner. The record and movie industry in recent years has taken an aggressive
                approach to stopping illegal downloading and file sharing. This has put many students at the nation's colleges
                and universities at some legal risk.
            </p><p><strong><em>Your actions when downloading or sharing files are
                    traceable and could result in a significant financial penalty to you!</em></strong></p>
            <p>For additional information, including options for obtaining music and movies legally over the Internet, go to the&nbsp;
                <a href='http://www.washington.edu/students/gencat/policy/p2pshare.html' target='_blank'>Peer-to-Peer File-Sharing
                    and Copyright Infringement</a> information page in the Student Guide.</p>
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I acknowledge that I have read the file-sharing notice.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

const Clery = (props) => {
    const key = "clery";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }
    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">Your Safety Your Health</h4>
            <h5 className="h3">Campus Security, Fire Safety and Drug Awareness</h5>

            <p>Your personal safety and the security of our campus community are of vital concern to the University of
                Washington. Available to you is the University's annual <em>Security and Fire Safety Report, and Drug-Free
                    Schools Act Information</em> report, as required by the Clery Act and Drug-Free Schools Act.</p>

            <p>This report includes statistics for the most recent three-year period on reported crimes that occurred on-campus,
                in certain off-campus buildings, on property owned or controlled by the University of Washington, Seattle or its
                affiliates as well as on public property within or immediately adjacent to and accessible from the campus as
                well as fire statistics from on-campus student housing facilities.</p>

            <p>The report also includes information regarding the law enforcement authority of the UW Police; policies and
                procedures concerning campus security, missing person, the sex offender registry and prohibited behaviors and
                weapons; and available resources for crime prevention, alcohol and other drug abuse and sexual assault education
                programs as well as information about fire safety.</p>

            <p><strong>Obtaining the Report</strong></p>
            <table className="mb-3">
                <tbody>
                    <tr>
                        <td className="pe-3">Online</td>
                        <td><a title="http://police.uw.edu/securityreport/" href="http://police.uw.edu/securityreport/"
                               target="_blank">http://police.uw.edu/securityreport</a></td>
                    </tr>
                    <tr>
                        <td className="pe-3">In Person</td>
                        <td>UW Police Department Bryants Building
                            1117 NE Boat St, Seattle Washington 98105</td>
                    </tr>
                    <tr>
                        <td className="pe-3">Order by Phone</td>
                        <td>206-543-0507</td>
                    </tr>
                </tbody>
            </table>

            <h5 className="h3">60-Day Crime/Incident Log</h5>

            <p>The UW Police Department maintains a 60-day crime/incident log for all reported incidents where a records number
                was generated. The log includes the date the crime/incident was reported, the date and time the incident
                occurred, general location of the incident, and disposition. To view the UW Campus 60-Day crime log visit <a
                    title="Crime Log" href="http://police.uw.edu/crimedata/60daylog/"
                    target="_blank">http://police.uw.edu/crimedata/60daylog</a> Hard copies may be obtained at the University of
                Washington Police Department.</p>

            <p>Harborview Medical Center maintains a separate 60-day crime log. Their crime log includes the type of crime, case
                report number, the date the crime was reported to Harborview Security Services Department, the date and time of
                occurrence, the general location of the crime and disposition if known. To request a hard copy of the 60-day
                crime log, call 206.744.4913.</p>
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I acknowledge receipt of this information.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

const Ferpa = (props) => {
    const key = "ferpa";
    const storeValue = acknowledgementsStore.getNewAcknowledgementValue(key) ?? false;
    const [isChecked, setIsChecked] = useState(storeValue);
    const handleChange = (e) => {
        setIsChecked(current => !current);
    }
    const submitForm = (e) => {
        e.preventDefault();
        if (isChecked) {
            props.updateAcknowledgement(key, isChecked);
            props.onSuccess();
        }
    }

    return (
        <>
            <h4 className="h2">UW Notification of Rights under FERPA for Postsecondary Institutions</h4>
            <p>The Family Educational Rights and Privacy Act (FERPA) affords eligible students certain rights with respect to
                their education records. (An <q>eligible student</q> under FERPA is a student who is 18 years of age or older or
                who attends a postsecondary institution at any age.)</p>
            <p>Additional information about FERPA for students can be found on the webpage of the Office of the University Registrar: <a
                href='https://registrar.washington.edu/students/ferpa'
                target='_blank'>https://registrar.washington.edu/students/ferpa</a>. That page includes information about how to
            restrict the release of directory information, and other FERPA resources.Directory information at the University of
            Washington is defined as a student’s name, address, email address, telephone numbers, major, and minor field(s) of
            study (including pre-major or undeclared), class, date of birth, enrollment status (e.g. graduate, undergraduate,
            professional, post-baccalaureate, or non-matriculated student, full- or part-time), participation in officially
            recognized activities and sports, weight and height if the student is a member of an intercollegiate athletic team,
            dates of attendance, degrees, honors, and offer received, and the most recent previous educational agency or
            institution attended by the student. You may opt out of directory information about you being released using the
            tools available in MyUW. Opting out will not prevent information about you that falls within directory information
            from being released as otherwise allowed or required by law.</p>
            <p>The rights provided by FERPA include:</p>
            <ol>
                <li>The right to inspect and review your education records within 45 days after the day the University of
                    Washington receives a request for access. You should submit to the registrar, dean, head of the academic
                    department a written request that identifies the record(s) you wish to inspect. The school official will
                    make arrangements for access and notify you of the time and place where the records may be inspected. If the
                    records are not maintained by the school official to whom the request was submitted, that official should
                    advise you of the correct official to whom the request should be addressed.</li>
                <li>
                    <p>The right to request the amendment of your education records that you believe are inaccurate, misleading,
                        or otherwise in violation of your privacy rights under FERPA. This process cannot be used to challenge
                        grades.</p>
                    <p>A student who wishes to ask the University to amend a record should write the school official responsible
                        for the record, clearly identify the part of the record the student wants changed, and specify why it
                        should be changed.</p>
                    <p>If the University decides not to amend the record as requested, you will be notified in writing of the
                        decision and your right to request a hearing regarding the request for amendment.</p>
                </li>
                <li>
                    <p>The right to provide written consent before the University discloses personally identifiable information
                        (PII) from your education records, except to the extent that FERPA authorizes disclosure without
                        consent.</p>
                    <p>The University discloses education records without a student's prior written consent under the FERPA
                        exception for disclosure to school officials with legitimate educational interests. School officials
                        include faculty, instructors, staff, student employees, volunteers, third party contractors, and any
                        individual UW has determined to have legitimate educational interests in accessing education records. An
                        individual has a legitimate educational interest when they need access to the education record to
                        perform their official duties; not to satisfy curiosity or other non-job related interests.</p>
                    <p>Upon request, the school also discloses education records without consent to officials of another school
                        in which a student seeks or intends to enroll.</p>
                </li>
                <li>The right to file a complaint with the U.S. Department of Education concerning alleged failures by the
                    University to comply with the requirements of FERPA. The name and address of the office that administers
                    FERPA is:
                    <div className="ps-4 my-3">
                        Student Privacy Policy Office <br/><br/>
                        U.S. Department of Education<br/>
                        400 Maryland Avenue, SW<br/>
                        Washington, DC 20202
                    </div>
                </li>
            </ol>
            <Form onSubmit={submitForm}>
                <Form.Check id={key} className="mb-3">
                    <Form.Check.Input
                        name={key}
                        type="checkbox"
                        defaultChecked={isChecked}
                        required
                        aria-required={true}
                        onChange={handleChange} />
                    <Form.Check.Label className="d-inline me-2 align-middle">
                        I have read the above FERPA Annual Notification.
                    </Form.Check.Label>
                </Form.Check>
                <Button aria-disabled={!isChecked} type="submit" className={classnames({"disabled": !isChecked})}>Continue</Button>
            </Form>
        </>
    )
}

// Default all the proptypes for acknowledgement components to the same values
const ackProps = {
    updateAcknowledgement: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}
Meningitis.propTypes = VoterRegistration.propTypes = Riaa.propTypes = Clery.propTypes = Upass.propTypes = FinancialResponsibility.propTypes = Ferpa.propTypes = ackProps;

class Acknowledgements extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = acknowledgementsStore;
        this.analyticsStore = appStore.getAnalyticsStore();
    }

    componentDidMount() {
        this.store.mount(this.props.onSuccess);
    }

    handleHide = () => {
        this.store.closeModal();
        this.props.onSuccess();
    }

    handleOpen = () => {
        this.store.openModal();
        this.analyticsStore.addEvent("RegPrev-AcknowledgementsModalOpen",{},{});
    }

    buildDoneComponent = (componentKey) => {
        if (componentKey) {
            let component
            switch (componentKey) {
                case "meningo":
                    component = <Meningitis updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "voter":
                    component = <VoterRegistration updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "riaa":
                    component = <Riaa updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "clery":
                    component = <Clery updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "upass":
                    component = <Upass updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "finliab":
                    component = <FinancialResponsibility updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
                case "ferpa":
                    component = <Ferpa updateAcknowledgement={this.store.updateAcknowledgement} />
                    break;
            }
            return (
                <div key={componentKey}>
                    {component}
                </div>
            );
        } else {
            return (
                <>
                    <div>Your Acknowledgements are complete.</div>
                    <div className="d-flex justify-content-end">
                        <Button onClick={this.handleHide}>
                            Close and Refresh
                        </Button>
                    </div>
                </>

            );
        }
    }

    buildErrorComponent = () => {
        return <RegistrationFailure isWithinModal />
    }

    render() {
        if (appStore.isStudent() && !appStore.isAdviser()) {
            let componentKey, counter;
            let isLast = false;

            if (
                this.store.state === States.done
                &&
                this.store.formData.hasOwnProperty("acknowledged")
                &&
                this.store.formData.hasOwnProperty("acknowledgedNew")
            ) {
                for (const [key, value] of Object.entries(this.store.formData.acknowledged)) {
                    if (
                        value === false
                        &&
                        (
                            !this.store.formData.acknowledgedNew.hasOwnProperty(key)
                            ||
                            this.store.formData.acknowledgedNew[key] === false
                        )
                    ) {
                        componentKey = key;
                        break;
                    }
                }

                let unacknowledged = Object.entries(this.store.formData.acknowledged).filter(([key, value]) => value === false).map(item => item[0]);

                counter = unacknowledged.indexOf(componentKey) !== -1 ?<>- <span aria-live="polite" aria-atomic="true">{unacknowledged.indexOf(componentKey) + 1} of {unacknowledged.length}</span></> : null;
                isLast = (unacknowledged.indexOf(componentKey) + 1) === unacknowledged.length;
            }

            return (
                <>
                    <Button onClick={this.store.openModal}>Complete Pre-Registration {this.props.isAfterRegDate ? "Steps Now" : "Acknowledgements"}</Button>
                    <Modal show={this.store.showModal}
                           size="lg"
                           onHide={this.handleHide}
                           backdrop="static"
                           aria-labelledby="modal-acknowledgements-title"
                           centered>
                        <Modal.Header closeButton>
                            <Modal.Title as="h3" id="modal-acknowledgements-title">Pre-Registration Acknowledgements {counter}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <SimpleState state={this.store.state}
                                         doneComponentBuilder={() => this.buildDoneComponent(componentKey)}
                                         errorComponentBuilder={this.buildErrorComponent}
                                         pendingComponentBuilder="dots"
                                         name="Acknowledgements" />
                        </Modal.Body>
                    </Modal>
                </>

            );
        } else {
            return (
                <Alert variant="danger" className="d-inline-flex align-items-center">
                    <FaExclamationCircle className="me-3 fs-5" aria-hidden={true} />
                    <div>You must be a student in order to complete acknowledgements.</div>
                </Alert>
            )
        }
    }
}

Acknowledgements.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    isAfterRegDate: PropTypes.bool
}

Acknowledgements.defaultProps = {
    isAfterRegDate: false
}

export default observer(Acknowledgements);
export {Meningitis, VoterRegistration, Riaa, Clery, Upass, FinancialResponsibility, Ferpa}
